import { CheckCircle2 } from "lucide-react";

import { TierPill } from "./EngagementBadges";
import { poll1Lookup } from "./poll1Helpers";
import type { Poll1Tier } from "./poll1Helpers";
import Button from "../../Components/Button";
import CommonModal from "../../Components/Modal";

type Props = {
  isOpen: boolean;
  accountName: string;
  period: string;
  score: number;
  poll1Tiers: Poll1Tier[];
  onReturn: () => void;
};

const ScoreRevealPanel = ({
  isOpen,
  accountName,
  period,
  score,
  poll1Tiers,
  onReturn,
}: Props) => {
  const tierObj = poll1Lookup(score, poll1Tiers);

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={onReturn}
      size="md"
      showHeader={false}
      usePortal
    >
      <div className="flex flex-col items-center text-center px-2 py-4">
        {/* Success icon */}
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-green-100 mb-4">
          <CheckCircle2 className="text-green-600" size={30} />
        </div>

        {/* Title */}
        <h2 className="text-lg font-bold text-gray-900 mb-1">
          Check-In Submitted!
        </h2>
        <p className="text-sm text-gray-500 mb-6">
          {accountName} · {period}
        </p>

        {/* Score */}
        <div className="w-full rounded-xl bg-gray-50 border border-gray-200 py-6 px-4 mb-5">
          <div className="text-[11px] font-semibold uppercase tracking-widest text-gray-400 mb-2">
            Self-Report Score
          </div>
          <div className="text-5xl font-extrabold text-gray-900 leading-none mb-3">
            {score}
            <span className="text-xl font-semibold text-gray-400"> / 8</span>
          </div>
          <TierPill tier={tierObj.tier} className="!text-sm !px-3 !py-1" />
        </div>

        {/* Message */}
        <p className="text-sm text-gray-500 leading-relaxed mb-6 max-w-[320px]">
          Your responses are saved and will inform the {period} leaderboard once
          the cycle closes and the ESL submits the draft for CCO approval.
        </p>

        {/* CTA */}
        <Button variant="primary" onClick={onReturn} className="w-full">
          Return to Portfolio
        </Button>
      </div>
    </CommonModal>
  );
};

export default ScoreRevealPanel;
